import React, { useEffect, useRef, useState} from "react";
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import {IconButton, Box, colors } from "@mui/material"
import useAxiosProtect from "../../../hooks/useAxiosProtect";
import months_list from '../../../example_data/dropdowns/clientModal/months';
import {Table, Button, Modal} from 'react-bootstrap';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer} from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import WaterModal from "./modals/WaterModal";
import ElectricityModal from "./modals/ElectricityModal";
import GasModal from "./modals/GasModal";
import Alert from 'react-bootstrap/Alert';
import { ExpandMore } from "@mui/icons-material";
import { EXCEL_FILE_BASE64 } from "../../../constants";
import FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import { waterUnitTypes } from "../../../example_data/dropdowns/clientModal/loggingComponents";
import UtilityTrendContainer from "./utility_trend_system/UtilityTrendContainer";

const UtilityReadings = props => {
    var init = useRef(true);
    const axiosProtect = useAxiosProtect();

    const [showFileError, setShowFileError] = useState(false);
    const [showFileSuccess, setShowFileSuccess] = useState(false);

    const [fileName, setFileName] = useState(null);
    let site_id = parseInt(window.location.href.split('/').slice(-1))
    
    const [utilityReadings, setUtilityReadings] = useState({
        water: [],
        electricity: [],
        gas: []
        
    });

    const formatCurrency = (value) => {
        if (typeof value !== "number" || isNaN(value)) return "$0.00";
        return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      };
      
      const formatNumber = (value) => {
        if (typeof value !== "number" || isNaN(value)) return "0";
        return value.toLocaleString();
      };

    const [activeUtilityType, setActiveUtilityType] = useState('');
    const [deleteUtilityType, setDeleteUtilityType] = useState('');
    const [selectedReading, setSelectedReading] = useState(null);
    
    const [siteID, setSiteID] = useState('');
    
    const [baselineData, setBaselineData] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [startDate, setStartDate] = useState(dayjs('2025-04-14'));
    const [endDate, setEndDate] = useState(dayjs('2025-05-14'));

    const [monthErr, setMonthErr] = useState('');
    const [yearErr, setYearErr] = useState('');

    const floatRegex = /^(|\d*\.?\d+|\d+\.)$/;
    const intRegex = /^(|\d+)$/;

    const addNewReading = (newReading, utilityType) => {
        setUtilityReadings(prevReadings => ({
            ...prevReadings,
            [utilityType]: [...(prevReadings[utilityType] || []), newReading]
        }));
    };
   
    useEffect(() => {
        const controller = new AbortController();
        let site_id = parseInt(window.location.href.split('/').slice(-1))
        if (site_id) {
            // Set the site id
            setSiteID(site_id)
        }
        
        const getBaselineData = async () => {
            try{
                let response = await axiosProtect.get(`/u/utilities/metrics?site_id=${site_id}`);
                if(response.status === 200){
                    if(response.data.metrics.length === 0) return;
                    setBaselineData(response.data.metrics[0])
                }
            }catch(error){
                console.log(error)
            }
        }
        
        const getUtilityReadings = async () => {
            try {
                const response = await axiosProtect.get(`/u/utilities/utilities?site_id=${site_id}`, {
                    signal: controller.signal
                });
                
                if (response.status === 200 && response.data.utilityBills) {
                    let utilityCopy = {...response.data.utilityBills};

                    utilityCopy.water.sort((a, b) => {
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    });

                    utilityCopy.electricity.sort((a, b) => {
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    });

                    utilityCopy.gas.sort((a, b) => {
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    });

                    setUtilityReadings(utilityCopy);
                    await getBaselineData();
                }
        
            } catch (err) {
                console.log(err);
            }
        };
        
        if(init.current){
            init.current = false;
            getUtilityReadings();
        }
    }, []);

    useEffect(() => {
        // console.log(utilityReadings)
    }, [utilityReadings])

    // Make months easier to understand
    const readableMonths = (params) => {
        for (let i = 0; i < months_list.length; i++) {
            if (months_list[i][0] === params.row.month) {
                return(months_list[i][1]);
            }
        }
        return '';
    }
    const handleDownload = () => {
        let sliceSize = 1024;
        let byteCharacters = atob(EXCEL_FILE_BASE64);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            let begin = sliceIndex * sliceSize;
            let end = Math.min(begin + sliceSize, bytesLength);
            let bytes = new Array(end - begin);

            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }

            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }

        FileSaver.saveAs(
            new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
            "utilitybilltemplate.xlsx"
        );
    }

    const handleFileUpload = async (e) => {
        try{
            // converting excel date value 
            const excelEpoch = 25568; 
            const millisecondsInDay = 86400000;
            // const jsTime = (jsonData[7][6] - excelEpoch) * millisecondsInDay;
            // const date = new Date(jsTime);

            const file = e.target.files[0];
            setFileName(file.name);

            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data);

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        
            const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: "",
            });

            let waterExcel = [];
            let elecExcel = [];
            let gasExcel = [];

            const waterUnits = jsonData[6][2].toLowerCase();
            const gasUnits = jsonData[6][9].toLowerCase();
            const elecUnits = jsonData[6][14].toLowerCase();
            const demandUnits = jsonData[6][16].toLowerCase();

            const date = jsonData[8][6]
            // console.log(date)
            const result = {};
            for (let i = 7; i < jsonData.length; i++) {
                const rowData = jsonData[i];
                const singleRow = {};

                let waterCost;

                // water params
                if (rowData[3] != ""){waterCost=rowData[3]}else{waterCost=0}
                let wasteWater;
                if (rowData[4] != ""){wasteWater=rowData[4]}else{wasteWater=0}
                let wasteWaterCost;
                if (rowData[5] != ""){wasteWaterCost=rowData[3]}else{wasteWaterCost=0}

                let waterStart;
                if (rowData[6] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[6]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        waterStart = `${yyyy}-${mm}-${dd}`;
                    
                }
                let WaterEnd;
                if (rowData[7] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[7]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        WaterEnd = `${yyyy}-${mm}-${dd}`;
                    
                }
                //water payload
                if (rowData[1] != "" && rowData[2] != "") {
                    singleRow.water = { 
                        units: waterUnits,
                        total_water: parseFloat(rowData[2]),
                        water_cost: parseFloat(waterCost),
                        total_wastewater: parseFloat(wasteWater),
                        wastewater_cost: parseFloat(wasteWaterCost),
                        total_bill_cost: parseFloat(rowData[1]),
                        start_date: waterStart,
                        end_date: WaterEnd, }; // add other data as needed
                }

                //gas params
                let gasCost;
                if (rowData[10] != ""){gasCost=rowData[10]}else{gasCost=0}
                let gasStart;
                if (rowData[11] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[11]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        gasStart = `${yyyy}-${mm}-${dd}`;
                    
                }
                let gasEnd;
                if (rowData[12] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[12]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        gasEnd = `${yyyy}-${mm}-${dd}`;
                    
                }
                //gas payload
                if (rowData[8] != "" && rowData[9] != "") {
                    singleRow.gas = { 
                        gas_units:gasUnits,
                        total_gas: parseFloat(rowData[9]),
                        gas_cost: parseFloat(gasCost),
                        total_bill_cost: parseFloat(rowData[8]),
                        start_date: gasStart,
                        end_date: gasEnd, };
                }

                //electricity params
                let elecCost;
                if (rowData[15] != ""){elecCost=rowData[15]}else{elecCost=0}
                let demandCost;
                if (rowData[17] != ""){demandCost=rowData[17]}else{demandCost=0}
                let powerFactor;
                if (rowData[18] != ""){powerFactor=rowData[18]}else{powerFactor=0.9}
                let globalAdjust;
                if (rowData[19] != ""){globalAdjust=rowData[19]}else{globalAdjust=0}
                let totalDemand;
                if (rowData[16] != ""){totalDemand=rowData[16]}else{totalDemand=0}
                
                let elecStart;
                if (rowData[20] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[20]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        elecStart = `${yyyy}-${mm}-${dd}`;
                    
                }
                let elecEnd;
                if (rowData[21] !=""){
                    const jsDate = XLSX.SSF.parse_date_code(rowData[21]);
                    
                        const yyyy = jsDate.y;
                        const mm = String(jsDate.m).padStart(2, '0');
                        const dd = String(jsDate.d).padStart(2, '0');
                        elecEnd = `${yyyy}-${mm}-${dd}`;
                    
                }

                //electricity payload
                if (rowData[13] != "" && rowData[14] != "") {
                    singleRow.electricity = { 
                        electricity_units: elecUnits,
                        total_electricity: parseFloat(rowData[14]),
                        electricity_cost: parseFloat(elecCost),
                        demand_units: demandUnits,
                        total_demand: parseFloat(totalDemand),
                        demand_cost: parseFloat(demandCost),
                        total_bill_cost: parseFloat(rowData[13]),
                        powerFactor: parseFloat(powerFactor),
                        global_adjustment: parseFloat(globalAdjust),
                        start_date: elecStart,
                        end_date: elecEnd,
                    };
                }
                
                if (Object.keys(singleRow).length != 0) {

                    const jsDate = XLSX.SSF.parse_date_code(rowData[0]);
                    const dateStr = jsDate ? `${new Date(jsDate.y, jsDate.m - 1).toLocaleString('default', { month: 'short' })}-${String(jsDate.y).slice(-2)}`: rowData[0];
                    // console.log(dateStr);
                    result[dateStr] = singleRow;  // set property as row date
                }
            
            }

            let payload = {
                bills: result
            };

            let response = await axiosProtect.post(`/u/utilities/bulk-upload?site_id=${site_id}`, payload);

            let utilityCopy = {...utilityReadings};

            if(response.data.water?.length > 0){
                utilityCopy.water.push(...response.data.water);

                utilityCopy.water.sort((a, b) => {
                    if (a.year !== b.year) return a.year - b.year;
                    return a.month - b.month;
                });
            }

            if(response.data.electricity?.length > 0){
                utilityCopy.electricity.push(...response.data.electricity);

                utilityCopy.electricity.sort((a, b) => {
                    if (a.year !== b.year) return a.year - b.year;
                    return a.month - b.month;
                });
            }

            if(response.data.gas?.length > 0){
                utilityCopy.gas.push(...response.data.gas);

                utilityCopy.gas.sort((a, b) => {
                    if (a.year !== b.year) return a.year - b.year;
                    return a.month - b.month;
                });
            }

            setUtilityReadings(utilityCopy);

            setShowFileSuccess(true);

            setTimeout(() => {
                setShowFileSuccess(false);
            }, 5000);

            e.target.value = '';

        }catch(error){
            setShowFileError(true);

            setTimeout(() => {
                setShowFileError(false);
            }, 5000);
            
            e.target.value = '';
        }    
    }

    return (
        <>
        {
            showFileError &&
            <Alert variant="danger" onClose={() => setShowFileError(false)} dismissible>
                <Alert.Heading>File upload error</Alert.Heading>
                <p>Something went wrong trying to upload your utility bill file. Please check the template and try again, or contact support.</p>
            </Alert>
        }

        {
            showFileSuccess &&
            <Alert variant="success" onClose={() => setShowFileError(false)} dismissible>
                <Alert.Heading>Successfully added bills</Alert.Heading>
                <p>Note that entries from your file that had invalid values in any of the required fields would have been omitted. Please double-check the newly added bills below to ensure they've been processed. Any entries associated with duplicate months would have also been skipped.</p>
            </Alert>
        }

        <UtilityTrendContainer/>

        <div style={{display:'flex', flexDirection:'row'}}>
            <div>
                <small>First:</small>
                <br/>
                <Button style={{ marginBottom: '2%' }} onClick={handleDownload}>Download Utility Bill Template</Button>
            </div>

            <div style={{width:'2vw'}}></div>

            <div>
                <small>Then:</small>
                <br/>
                <label style={{borderRadius: '5px', color: "#fff", background: "#0d6efd", border: "1px solid #ccc", display: "inline-block", padding: "6px 12px", cursor: "pointer"}} htmlFor="file-upload" class="custom-file-upload">
                    Upload Utility Bill
                </label>
                <input style={{display: "none"}}id="file-upload" type="file" onChange={handleFileUpload} />
            </div>
        </div>

        <br/>

        <div style={{borderRadius: '15px', boxShadow:'2px 6px 12px rgb(164, 164, 164)', marginBottom: '25px'}}>
            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                    <h4  style={{ width: '45%', flexShrink: 0 }}>Water Readings{utilityReadings.water.length > 0 ? ` (${utilityReadings.water.length})` : ''}</h4>
                </AccordionSummary>
                <AccordionDetails>
                <Box textAlign='center'>
            <Button variant='outline-dark' style={{ marginBottom: '2%' }} onClick={() => {
                setActiveUtilityType('water');
                setSelectedReading(null);
                setShowAddModal(true);
            }}>
                <strong>Add Water Readings </strong>
            </Button>
            </Box>
            
            <Table>
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Water Reading (m<sup>3</sup>)</th>
                        <th>Total Water Cost</th>
                        <th>Total Waste Water</th>
                        <th>Total Waste Water Cost</th>
                        <th>Total Invoice</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {(utilityReadings.water || []).map(reading => (
                    <tr key={reading.id}>
                        <td>{reading.year }</td>
                        <td>{readableMonths({ row: reading })}</td>
                        <td>{formatNumber(reading.total_water)}</td> 
                        <td>{formatCurrency(reading.water_cost)}</td> 
                        <td>{formatNumber(reading.total_wastewater)}</td> 
                        <td>{formatCurrency(reading.wastewater_cost)}</td> 
                        <td>{formatCurrency(reading.total_bill_cost)}</td> 
                        <td>
                            <IconButton onClick={() => {
                                setActiveUtilityType('water');
                                
                                setSelectedReading(reading);
                            }}>
                                <EditTwoToneIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                setDeleteUtilityType('water');
                                
                                setShowDeleteModal(true);
                                setSelectedReading(reading);
                            }}>
                                <DeleteTwoToneIcon style={{fill: "red"}}/>
                            </IconButton>
                            
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            </AccordionDetails>
            </Accordion>
            </div>

            <div style={{borderRadius: '15px', boxShadow:'2px 6px 12px rgb(164, 164, 164)', marginBottom: '25px'}}>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <h4  style={{ width: '45%', flexShrink: 0 }}>Electricity Readings{utilityReadings.electricity.length > 0 ? ` (${utilityReadings.electricity.length})` : ''}</h4>
                </AccordionSummary>
                <AccordionDetails>
                <Box textAlign='center'>
            <Button variant='outline-dark' style={{ marginBottom: '2%' }} onClick={() => {
                setActiveUtilityType('electricity');
                setSelectedReading(null);
                setShowAddModal(true);
            }}>
                <strong>Add Electricity Readings</strong>
            </Button>
            </Box>
            <Table>
                
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Total Electricity Reading (KWH)</th>
                        <th>Total Electricity Cost</th>
                        <th>Total Demand KW</th>
                        <th>Total Demand KW Cost</th>
                        <th>Total Invoice</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {(utilityReadings.electricity || []).map(reading => (
                    <tr key={reading.id}>
                        <td>{reading.year}</td>
                        <td>{readableMonths({ row: reading })}</td>
                        <td>{formatNumber(reading.total_electricity)}</td>
                        <td>{formatCurrency(reading.electricity_cost)}</td>
                        <td>{formatNumber(reading.total_demand)}</td> 
                        <td>{formatCurrency(reading.demand_cost)}</td> 
                        <td>{formatCurrency(reading.total_bill_cost)}</td> 
                        <td>
                            <IconButton onClick={() => {
                                setActiveUtilityType('electricity');
                                setSelectedReading(reading);
                            }}>
                                <EditTwoToneIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                setDeleteUtilityType('electricity');
                                
                                setShowDeleteModal(true);
                                setSelectedReading(reading);
                            }}>
                                <DeleteTwoToneIcon style={{fill: "red"}}/>
                            </IconButton>
                            
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            </AccordionDetails>
            </Accordion>
            </div>
            
            <div style={{borderRadius: '15px', boxShadow:'2px 6px 12px rgb(164, 164, 164)', marginBottom: '25px'}}>
            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                >
                    <h4  style={{ width: '45%', flexShrink: 0 }}>Gas Readings{utilityReadings.gas.length > 0 ? ` (${utilityReadings.gas.length})` : ''}</h4>
                    
                </AccordionSummary>
                <AccordionDetails>
                <Box textAlign='center'>
            <Button variant='outline-dark' style={{ marginBottom: '2%' }} onClick={() => {
                setActiveUtilityType('gas');
                setSelectedReading(null);
                setShowAddModal(true);
            }}>
                <strong>Add Gas Readings</strong>
            </Button>
            </Box>
            <Table>
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Gas Reading</th>
                        <th>Total Gas Cost</th>
                        <th>Total Invoice</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {(utilityReadings.gas || []).map(reading => (
                    <tr key={reading.id}>
                        
                        <td>{reading.year}</td>
                        <td>{readableMonths({ row: reading })}</td>
                        <td>{formatNumber(reading.total_gas)}</td> 
                        <td>{formatCurrency(reading.gas_cost)}</td> 
                        <td>{formatCurrency(reading.total_bill_cost)}</td>
                        <td>
                            <IconButton onClick={() => {
                                setActiveUtilityType('gas');
                                setSelectedReading(reading);
                            }}>
                                <EditTwoToneIcon />
                            </IconButton>
                            <IconButton onClick={() => {
                                setDeleteUtilityType('gas');
                                
                                setShowDeleteModal(true);
                                setSelectedReading(reading);
                            }}>
                                <DeleteTwoToneIcon style={{fill: "red"}}/>
                            </IconButton>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
                </AccordionDetails>
            </Accordion>
            
            </div>

            <Modal 
                show={showAddModal} 
                onHide={() => setShowAddModal(false)} 
                backdrop="static"
                centered
                className="opp-modal-root"
                backdropClassName="opp-modal-backdrop"
                dialogClassName="opp-modal-cw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Utility Reading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                                <DatePicker label="Start Date" value={startDate} onChange={(newvalue) => setStartDate(newvalue)} />
                                <DatePicker label="End Date" value={endDate} onChange={(newvalue) => setEndDate(newvalue)} />
                            </DemoContainer>
                            
                        </LocalizationProvider>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-brand-bg" type='submit' onClick={() => {
                        if (activeUtilityType && ['water', 'electricity', 'gas'].includes(activeUtilityType)) {
                            const newEntry = {
                                startDate: startDate,
                                endDate: endDate
                                
                            };
                            setUtilityReadings(prev => ({
                                ...prev,
                                [activeUtilityType]: [...(prev[activeUtilityType] || []), newEntry]
                            }));
                            
                            setShowAddModal(false);
                        } else {
                            console.error("Invalid utility type:", activeUtilityType);
                        }
                    }}
                >
                    Create
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal 
                show={showDeleteModal} 
                onHide={() => setShowDeleteModal(false)} backdrop="static"
                centered
                className="opp-modal-root"
                backdropClassName="opp-modal-backdrop"
                dialogClassName="opp-modal-cw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Utility Reading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <p>are you sure you want to delete the following utility?</p>
                        {selectedReading&&<p>{selectedReading.year}-{selectedReading.month}</p>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-brand-bg" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                    <Button className="btn-brand-bg" type='submit' onClick={async () => {
                try {
                    
                    await axiosProtect.delete(`/u/utilities?utilityType=${deleteUtilityType}&id=${selectedReading.id}`);
                    
                    
                    setUtilityReadings(prev => ({
                        ...prev,
                        [deleteUtilityType]: prev[deleteUtilityType].filter(r => r.id !== selectedReading.id)
                    }));

                    // Close the modal
                    setShowDeleteModal(false);
                    setSelectedReading(null);
                } catch (error) {
                    console.error("Error deleting utility reading:", error);
                }
            }}
                        
                >
                    Delete
                    </Button>
                </Modal.Footer>
            </Modal>
            {activeUtilityType === 'water' && selectedReading && (<WaterModal reading={selectedReading} onClose={() => setActiveUtilityType('')} onReadingCreated={(newReading) => {
            const formattedReading = newReading.newRecord;
            
            setUtilityReadings(prev => ({
                ...prev,
                water: prev.water
                    .filter(row => row.id !== selectedReading.id)  // Remove the blank row
                    .concat(formattedReading) // Add the new row
                    .sort((a, b) => { // resort the array to ensure billsare in order
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    })
            }));
            
            // Clear the selected reading
            setSelectedReading(null);
        }}/>)}
            {activeUtilityType === 'electricity' && selectedReading && (<ElectricityModal reading={selectedReading} onClose={() => setActiveUtilityType('')} onReadingCreated={(newReading) => {
            const formattedReading = newReading.newRecord;
            
            setUtilityReadings(prev => ({
                ...prev,
                electricity: prev.electricity
                    .filter(row => row.id !== selectedReading.id)  // Remove the blank row
                    .concat(formattedReading)  // Add the new row
                    .sort((a, b) => { // resort the array to ensure billsare in order
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    })
            }));
            
            // Clear the selected reading
            setSelectedReading(null);
        }} />)}
            {activeUtilityType === 'gas' && selectedReading && (<GasModal reading={selectedReading} onClose={() => setActiveUtilityType('')} onReadingCreated={(newReading) => {
            const formattedReading = newReading.newRecord;
            
            setUtilityReadings(prev => ({
                ...prev,
                gas: prev.gas
                    .filter(row => row.id !== selectedReading.id)  // Remove the blank row
                    .concat(formattedReading)  // Add the new row
                    .sort((a, b) => { // resort the array to ensure billsare in order
                        if (a.year !== b.year) return a.year - b.year;
                        return a.month - b.month;
                    })
            }));
            
            // Clear the selected reading
            setSelectedReading(null);
        }}/>)}               
        </>

    );
}

export default UtilityReadings;